/**
 * Backend-truthful org-role labels. Backend enum is
 * `organization_users.role CHECK (admin | audit | member)` (schema.sql:84);
 * the earlier `supervisor`/`user` vocabulary was a frontend error. Display
 * labels are Admin / Auditor / Member (domain/org.ts).
 */
import type { OrgRole } from '@/domain'

const ROLE_LABELS: Record<OrgRole, string> = {
  admin: 'Admin',
  audit: 'Auditor',
  member: 'Member',
}

/**
 * Humanize a wire role into its display label. Tolerates an unknown/legacy
 * string (e.g. a stale `supervisor`) by title-casing it rather than throwing,
 * so the chrome never renders a raw lowercase token to a CISO.
 */
export function orgRoleLabel(role: string | undefined): string {
  if (role && role in ROLE_LABELS) return ROLE_LABELS[role as OrgRole]
  if (!role) return ''
  return role.charAt(0).toUpperCase() + role.slice(1)
}
